import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactRequestQuotationWithDetail } from '../contact-request-quotation-with-detail';
import * as moment from 'moment';
import Decimal from 'decimal.js';
import { SalesProduct } from '../sales-product';
import { QuotationTemplate } from '../quotation-template';
import { QuotationTemplateProduct } from '../quotation-template-product';

@Injectable({
  providedIn: 'root'
})
export class LeadQuotationService {

  constructor(
    private builder: FormBuilder
  ) { }

  public quotationForm!: FormGroup | null;
  public selectedQuotationTemplate!: QuotationTemplate;
  public productsToDelete!: QuotationTemplateProduct[];

  setQuotationRequest(quotation: ContactRequestQuotationWithDetail){
    this.quotationForm = this.builder.group({
      description: quotation.description,
      comment: quotation.comment,
      products: this.builder.array([]),
      baseCurrency: quotation.baseCurrency,
      secondCurrency: quotation.secondCurrency,
      quotationDate: moment().toDate(),
      dueDate: null,
      deposit: new Decimal(250.00),
      priceIncludes: quotation.priceIncludes,
      priceNotIncludes: quotation.priceNotIncludes
    });
    this.initProducts(quotation.productList);
  }

  initProducts(productList: SalesProduct[]) {
    let array = this.quotationForm!.get("products") as FormArray;

    for (let product of productList) {
      array.controls.push(this.builder.group({
        type: product.productType,
        description: product.description,
        amount: [product.amount.toFixed(2), Validators.pattern(/^-?[.\d]+$/)],
        currency: product.currency,
        activeMenu: false,
        id: null
      }));
    }
  }

}
